import { useState, useEffect } from "react";
import { Mail, ArrowLeft } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import AuthLayout from "../../components/auth/AuthLayout";
import AuthInput from "../../components/auth/AuthInput";
import AuthButton from "../../components/auth/AuthButton";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { 
  forgotPassword, 
  clearError, 
  selectAuthLoading, 
  selectAuthError
} from "../../store/slices/authSlice";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  
  const dispatch = useAppDispatch();
  const loading = useAppSelector(selectAuthLoading);
  const error = useAppSelector(selectAuthError);

  const handleSendResetEmail = async () => {
    if (!email) {
      toast.error("Please enter your email address");
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    const result = await dispatch(forgotPassword(email));
    if (forgotPassword.fulfilled.match(result)) {
      toast.success("Reset email sent successfully!");
      navigate(`/reset-password?email=${encodeURIComponent(email)}`, { replace: true });
    }
  };

  useEffect(() => {
    if (error) {
      toast.error(error);
      dispatch(clearError());
    }
  }, [error, dispatch]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendResetEmail();
    }
  };



  return (
    <AuthLayout 
      title="Forgot Password" 
      subtitle="Enter your email address to receive a password reset link"
    >
      {/* Email Input */}
      <AuthInput
        icon={Mail}
        type="email"
        placeholder="Enter your email address"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        onKeyPress={handleKeyPress}
      />

      {/* Send Reset Email Button */}
      <AuthButton
        onClick={handleSendResetEmail}
        loading={loading}
        loadingText="Sending reset email..."
      >
        Send Reset Link
      </AuthButton>

      {/* Back to Login Link */}
      <Link 
        to="/signin" 
        className="flex gap-2 justify-center items-center text-xs text-emerald-600 hover:text-emerald-700"
      >
        <ArrowLeft size={14} />
        Back to login
      </Link>
    </AuthLayout>
  );
}
